import React, { Component } from 'react';
import './App.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import { BrowserRouter } from 'react-router-dom';
import AppRouting from './app-routing';
class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <AppRouting />
      </BrowserRouter>
    )
  }
}

export default App
